import { Alert, AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, AlertIcon, Badge, Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Button, Center, Flex, FormControl, FormLabel, IconButton, Input, InputGroup, InputLeftElement, Link, Menu, MenuButton, MenuItem, MenuList, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Popover, PopoverArrow, PopoverBody, PopoverContent, PopoverTrigger, Select, Skeleton, Stack, Table, TableContainer, Tbody, Td, Text, Textarea, Th, Thead, Tr, useColorModeValue, useDisclosure, useToast, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader, DrawerOverlay, HStack, Tooltip, Icon, InputRightElement, Card, CardBody } from '@chakra-ui/react'
import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { DateRange } from 'react-date-range';
import format from 'date-fns/format';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import fr from 'date-fns/locale/fr';
import { useStateContext } from '../../../context/ContextProvider';
import axiosClient from '../../../axios-client';
import { DeleteIcon, EditIcon, HamburgerIcon, SearchIcon, AttachmentIcon, CloseIcon, ChevronLeftIcon, ChevronRightIcon } from '@chakra-ui/icons';
import { GrPowerReset } from 'react-icons/gr';
import { RiFileExcel2Fill } from 'react-icons/ri';
import { PiPlusBold } from 'react-icons/pi';
import { IoBarChartSharp } from 'react-icons/io5';
import { FaFilePdf, FaImage } from 'react-icons/fa';
import Resizer from "react-image-file-resizer";
import { useTranslation } from 'react-i18next';
import { Bar } from 'react-chartjs-2';
import MyPagination from '../../../components/MyPagination';
import {
    Chart as ChartJS,
    BarElement,
    CategoryScale,
    LinearScale,
    Tooltip as ChartTooltip,
    Legend,
} from "chart.js";
import ReactSelect from 'react-select';
import { handlePriceChange, formatPriceForBackend } from '../../../utils/priceFormatter';
import { AsyncPaginate } from 'react-select-async-paginate';

ChartJS.register(BarElement, CategoryScale, LinearScale, ChartTooltip, Legend);

function GestCharges() {
    const navigate = useNavigate()
    const { t } = useTranslation();
    const { user, setToken, setUser, currentBusiness } = useStateContext();
    const toast = useToast()
    const cancelRef = React.useRef()

    const [date, setDate] = useState("")
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [isExportAlertOpen, setIsExportAlertOpen] = useState(false);
    const [productsNames, setProductsNames] = useState([]);
    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState();
    const [selectedProductFilter, setSelectedProductFilter] = useState('');
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [isEdit, setIsEdit] = useState(false)
    const [message, setMessage] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [data, setData] = useState([]);
    const [paginationData, setPaginationData] = useState()
    const [loadingData, setLoadingData] = useState(true)
    const [chargeData, setChargeData] = useState(null);
    const [chargeId, setChargeId] = useState('');
    const [selectedCategory, setSelectedCategory] = useState("");
    const [selectedOption, setSelectedOption] = useState(null);
    const [marketingType, setMarketingType] = useState("");
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [amount, setAmount] = useState();
    const [dateCharge, setDateCharge] = useState("");
    const [dateDebut, setDateDebut] = useState("");
    const [dateFin, setDateFin] = useState("");
    const [dateStartFilter, setDateStartFilter] = useState("");
    const [dateEndFilter, setDateEndFilter] = useState("");
    const [isRange, setIsRange] = useState(false);
    const [receipts, setReceipts] = useState([]);
    const [chargesStats, setChargesStats] = useState();
    const [currentPage, setCurrentPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [deleteType, setDeleteType] = useState("charge"); // "charge" or "receipt"
    const [receiptToDelete, setReceiptToDelete] = useState(null);

    const handlePageSizeChange = (event) => {
        const newSize = parseInt(event.target.value, 10);
        setPageSize(newSize);
        setCurrentPage(0);
    };

    const colorbg = useColorModeValue('white', '#2d3748')
    const txtcolor = useColorModeValue('black', 'white')
    const colorbghover = useColorModeValue('#e2e8f0', '#171923')
    const selectBg = useColorModeValue('white', '#2d3748')
    const selectColor = useColorModeValue('black', 'white')
    const selectBorder = useColorModeValue('#e2e8f0', '#4a5568')

    const customSelectStyles = {
        control: (provided) => ({
            ...provided,
            backgroundColor: selectBg,
            color: selectColor,
            borderColor: selectBorder,
            borderRadius: '12px',
            '&:hover': {
                borderColor: 'purple.400',
            }
        }),
        menu: (provided) => ({
            ...provided,
            backgroundColor: selectBg,
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? colorbghover : selectBg,
            color: selectColor,
        }),
        singleValue: (provided) => ({
            ...provided,
            color: selectColor,
        }),
        input: (provided) => ({
            ...provided,
            color: selectColor,
        }),
    };

    const today = new Date().toISOString().split('T')[0];

    const onOpenDrawer = () => setIsDrawerOpen(true);
    const onCloseDrawer = () => setIsDrawerOpen(false);
    const onOpenAlert = () => setIsAlertOpen(true);
    const onCloseAlert = () => setIsAlertOpen(false);
    const onOpenExportAlert = () => setIsExportAlertOpen(true);
    const onCloseExportAlert = () => setIsExportAlertOpen(false);

    const categories = [
        { key: "Delivery", label: t("Delivery") },
        { key: "Marketing", label: t("Marketing") },
        { key: "Salaries", label: t("Salaries") },
        { key: "Stock", label: t("Stock") },
        { key: "Shipping", label: t("Shipping") },
        { key: "Storage", label: t("Storage") },
        { key: "fullfilment", label: t("fullfilment") },
        { key: "service cod", label: t("service cod") },
        { key: "Packaging", label: t("Packaging") },
        { key: "Maintenance", label: t("Maintenance") },
        { key: "Insurance", label: t("Insurance") },
        { key: "taxes", label: t("taxes") },
        { key: "Material", label: t("Material") },
        { key: "Subscription", label: t("Subscription") },
        { key: "call center", label: t("call center") },
        { key: "rent", label: t("rent") },
        { key: "Freelancer", label: t("Freelancer") },
        { key: "Autre", label: t("Autre") }
    ];

    const labels = categories.map(c => c.label);

    const getCategoryLabel = (key) => {
        const legacyMapping = {
            "Livraison": "Delivery",
            "Salaires": "Salaries",
            "FraisDeStockage": "Storage",
            "Frais de stockage": "Storage",
            "FraisDemballage": "Packaging",
            "Frais d'emballage": "Packaging",
            "FraisDeMaintenance": "Maintenance",
            "Frais de maintenance": "Maintenance",
            "FraisDassurance": "Insurance",
            "Frais d'assurance": "Insurance",
            "FraisDeServiceClient": "call center",
            "Frais de service client": "call center",
            "FraisDeMatériel": "Material",
            "Frais de matériel": "Material",
            "AbonnementPlateforme": "Subscription",
            "AbonnementPlateformes": "Subscription",
            "Abonnement aux plateformes": "Subscription"
        };
        const normalizedKey = legacyMapping[key] || key;
        const cat = categories.find(c => c.key === normalizedKey);
        return cat ? cat.label : (t(key) || key);
    };

    const dataChart = {
        labels: labels,
        datasets: [{
            label: t("Charges"),
            data: [
                chargesStats?.delivery || 0,
                chargesStats?.marketing || 0,
                chargesStats?.salaries || 0,
                chargesStats?.stock || 0,
                chargesStats?.shipping || 0,
                chargesStats?.storage || 0,
                chargesStats?.fullfilment || 0,
                chargesStats?.service_cod || 0,
                chargesStats?.packaging || 0,
                chargesStats?.maintenance || 0,
                chargesStats?.insurance || 0,
                chargesStats?.taxes || 0,
                chargesStats?.material || 0,
                chargesStats?.subscription || 0,
                chargesStats?.call_center || 0,
                chargesStats?.rent || 0,
                chargesStats?.freelancer || 0,
                chargesStats?.autre || 0
            ],
            backgroundColor: "rgba(153, 102, 255, 0.2)",
            borderColor: "rgb(153, 102, 255)",
            borderWidth: 1,
        }],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: { display: false },
            title: { display: true, text: t('Répartition des charges'), font: { size: 16 } }
        },
    };

    const loadProductOptions = async (search, loadedOptions, { page }) => {
        try {
            const res = await axiosClient.get(`/products/get_All_Products_names/?client=${user?.id}&page_size=20&page=${page}&search_term=${search}&userRole=${user?.role}&business=${currentBusiness?.id}`, { hideLoader: true });
            const results = res.data.results || [];
            const hasMore = res.data.next !== null && res.data.next !== undefined;

            return {
                options: results.map(product => ({
                    value: product.id,
                    label: product.title
                })),
                hasMore: hasMore,
                additional: {
                    page: page + 1,
                },
            };
        } catch (error) {
            // // console.error('Error fetching products', error);
            return { options: [], hasMore: false };
        }
    };

    const fetchProductsNames = async (userId, userRole) => {
        // Le fetching est maintenant géré dynamiquement par loadProductOptions
    };

    const [dateRange, setDateRange] = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection'
        }
    ]);

    const [filterDateRange, setFilterDateRange] = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection'
        }
    ]);

    function empty() {
        setTitle(""); setDescription(""); setAmount(""); setDateCharge("");
        setSelectedOption(null); setMarketingType(""); setSelectedProduct(null); setMessage("");
        setIsRange(false); setDateDebut(""); setDateFin(""); setReceipts([]);
        setDateRange([{ startDate: new Date(), endDate: new Date(), key: 'selection' }]);
    }

    const resetFilters = () => {
        setSearchTerm("");
        setSelectedCategory("");
        setSelectedProductFilter(null);
        setDateStartFilter("");
        setDateEndFilter("");
        setFilterDateRange([{ startDate: new Date(), endDate: new Date(), key: 'selection' }]);
        setCurrentPage(0);
    };

    const handleExportExcel = async () => {
        try {
            const response = await axiosClient.get(`/export-charges/${user?.id}/?search_term=${searchTerm}&category=${selectedCategory}&dateDebut=${dateStartFilter}&dateFin=${dateEndFilter}&product=${selectedProductFilter ? selectedProductFilter.value : ''}&business=${currentBusiness?.id}`, {
                responseType: 'blob',
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'charges.xlsx');
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);

            toast({
                description: t("Le fichier a été exporté avec succès."),
                variant: 'left-accent',
                status: 'success',
                duration: 3000,
                isClosable: true,
                position: 'bottom-right'
            });
        } catch (error) {
            toast({
                description: t("Une erreur s'est produite lors de l'exportation du fichier."),
                variant: 'left-accent',
                status: 'error',
                duration: 3000,
                isClosable: true,
                position: 'bottom-right'
            });
        }
    };

    const [expandedRows, setExpandedRows] = useState({});

    const toggleRow = (id) => {
        setExpandedRows(prev => ({ ...prev, [id]: !prev[id] }));
    }

    const fetchData = useCallback(() => {
        if (!user?.id) return;
        setLoadingData(true);
        axiosClient.get(`/charges/getAllCharges/?page_size=${pageSize}&page=${currentPage + 1}&search_term=${searchTerm}&category=${selectedCategory}&client=${user?.id}&date=${date}&date_start=${dateStartFilter}&date_end=${dateEndFilter}&product=${selectedProductFilter ? selectedProductFilter.value : ''}&business=${currentBusiness?.id}`)
            .then((response) => {
                const results = response.data.results || response.data;
                setData(Array.isArray(results) ? results : []);
                setPaginationData(response.data.results ? response.data : null);
                setLoadingData(false);
            })
            .catch((error) => {
                // // console.error(error);
                setLoadingData(false);
            });

        axiosClient.get(`/charges/getCharges/?client=${user.id}&dateStart=${dateStartFilter}&dateEnd=${dateEndFilter}&product=${selectedProductFilter ? selectedProductFilter.value : ''}&userRole=${user.role}&business=${currentBusiness?.id}`)
            .then((response) => setChargesStats(response.data))
            .catch(() => {});

    }, [user, currentBusiness, pageSize, currentPage, searchTerm, selectedCategory, date, dateStartFilter, dateEndFilter, selectedProductFilter]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const AjoutCharge = () => {
        if (!title || !selectedOption || !amount || (!isRange && !dateCharge) || (isRange && (!dateDebut || !dateFin)) || (selectedOption === "Marketing" && !marketingType)) {
            setMessage(t("Veuillez remplir tous les champs obligatoires"));
            return;
        }
        const formData = new FormData()
        formData.append("title", title)
        formData.append("description", description)
        formData.append("category", selectedOption)
        formData.append("marketing_type", selectedOption === "Marketing" ? marketingType : "")
        formData.append("amount", formatPriceForBackend(amount))
        if (isRange) {
            formData.append("date_debut", dateDebut)
            formData.append("date_fin", dateFin)
        } else {
            formData.append("date_charge", dateCharge)
        }
        formData.append("business", currentBusiness?.id)
        if (selectedProduct) formData.append("product", selectedProduct.value)
        formData.append("added_by", user.id)
        receipts.forEach(file => formData.append('receipts', file));

        axiosClient.post('/charges/', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(() => {
                fetchData();
                onClose();
                empty();
                toast({ description: t("Charge ajoutée avec succès"), status: 'success', variant: 'left-accent' });
            })
            .catch(err => setMessage(err.response?.data?.error || t("Erreur lors de l'ajout")));
    }

    const UpdateCharge = (id) => {
        if (!title || !selectedOption || !amount || (!isRange && !dateCharge) || (isRange && (!dateDebut || !dateFin)) || (selectedOption === "Marketing" && !marketingType)) {
            setMessage(t("Veuillez remplir tous les champs obligatoires"));
            return;
        }
        const formData = new FormData();
        formData.append("title", title)
        formData.append("description", description)
        formData.append("amount", formatPriceForBackend(amount))
        if (isRange) {
            formData.append("date_debut", dateDebut)
            formData.append("date_fin", dateFin)
            formData.append("date_charge", "")
        } else {
            formData.append("date_charge", dateCharge)
            formData.append("date_debut", "")
            formData.append("date_fin", "")
        }
        formData.append("category", selectedOption)
        formData.append("marketing_type", selectedOption === "Marketing" ? marketingType : "")
        if (selectedProduct) formData.append("product", selectedProduct.value)
        receipts.forEach(file => formData.append('receipts', file));

        axiosClient.patch(`/charges/${id}/`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(() => {
                fetchData();
                onClose();
                empty();
                toast({ description: t("Charge modifiée avec succès"), status: 'success', variant: 'left-accent' });
            })
            .catch(err => setMessage(err.response?.data?.error || t("Erreur lors de la modification")));
    }

    const handleDelete = (id) => {
        if (deleteType === "charge") {
            axiosClient.delete(`/charges/${id}/`)
                .then(() => {
                    setData(data.filter(row => row.id !== id));
                    onCloseAlert();
                    toast({ description: t("Charge supprimée"), status: 'warning', variant: 'left-accent' });
                })
                .catch(() => {});
        } else if (deleteType === "receipt") {
            if (receiptToDelete === 'legacy') {
                axiosClient.patch(`/charges/${chargeId}/`, { recu: null })
                    .then(() => {
                        fetchData();
                        if (chargeData) setChargeData({ ...chargeData, recu: null });
                        onCloseAlert();
                        toast({ description: t("Ancien reçu supprimé"), status: 'success' });
                    })
                    .catch(() => {});
            } else {
                axiosClient.delete(`/charges/deleteReceipt/?receiptId=${receiptToDelete}`)
                    .then(() => {
                        fetchData();
                        if (chargeData) {
                            setChargeData({
                                ...chargeData,
                                receipts: (chargeData.receipts || []).filter(r => r.id !== receiptToDelete)
                            });
                        }
                        onCloseAlert();
                        toast({ description: t("Reçu supprimé"), status: 'success' });
                    })
                    .catch(() => {});
            }
        }
    }

    const confirmDeleteReceipt = (receiptId) => {
        setDeleteType("receipt");
        setReceiptToDelete(receiptId);
        onOpenAlert();
    }

    return (
        <Box position={"relative"}>
            <Flex zIndex={999} position={"fixed"} bottom={5} right={3}>
                <Button onClick={() => { setIsEdit(false); empty(); onOpen(); }} colorScheme='purple'><PiPlusBold size={18} /></Button>
            </Flex>

            <Box mt={2} mb={5}>
                <Breadcrumb fontWeight="medium" fontSize="2xl">
                    <BreadcrumbItem>
                        <BreadcrumbLink onClick={() => navigate('/')}>{t("Accueil")}</BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbItem isCurrentPage>
                        <BreadcrumbLink>{t("Charges")}</BreadcrumbLink>
                    </BreadcrumbItem>
                </Breadcrumb>
            </Box>

            <Card rounded="2xl" shadow="sm" border="1px" borderColor={useColorModeValue('gray.100', 'gray.700')}>
                <CardBody p={6}>
                    <Flex gap={4} mb={6} wrap="wrap" align="center">
                        <InputGroup w={{ base: "100%", md: "300px" }}>
                            <InputLeftElement children={<SearchIcon color='gray.300' />} />
                            <Input placeholder={t("Recherche...")} value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} rounded="xl" />
                        </InputGroup>
                        <Select w={{ base: "100%", md: "200px" }} value={selectedCategory} onChange={(e) => setSelectedCategory(e.target.value)} rounded="xl">
                            <option value="">{t("Toutes les catégories")}</option>
                            {categories.map(c => <option key={c.key} value={c.key}>{c.label}</option>)}
                        </Select>
                        <Box w={{ base: "100%", md: "220px" }} zIndex={10}>
                            <AsyncPaginate
                                loadOptions={loadProductOptions}
                                additional={{ page: 1 }}
                                value={selectedProductFilter}
                                onChange={(option) => setSelectedProductFilter(option)}
                                placeholder={t("Filtrer par produit")}
                                isClearable
                                noOptionsMessage={() => t("Aucun produit trouvé")}
                                styles={{
                                    control: (baseStyles, state) => ({
                                        ...baseStyles,
                                        borderRadius: '12px',
                                        backgroundColor: selectBg,
                                        color: selectColor,
                                        borderColor: state.isFocused ? '#805AD5' : selectBorder,
                                        boxShadow: state.isFocused ? '0 0 0 1px #805AD5' : 'none',
                                        minHeight: '40px',
                                        fontSize: '14px',
                                        transition: 'border-color 0.2s, box-shadow 0.2s',
                                        '&:hover': {
                                            borderColor: '#805AD5',
                                        },
                                    }),
                                    menu: (provided) => ({
                                        ...provided,
                                        backgroundColor: selectBg,
                                        borderRadius: '12px',
                                        boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
                                        border: `1px solid ${selectBorder}`,
                                        zIndex: 9999,
                                        overflow: 'hidden',
                                    }),
                                    menuList: (provided) => ({
                                        ...provided,
                                        padding: '4px',
                                        maxHeight: '220px',
                                    }),
                                    option: (provided, state) => ({
                                        ...provided,
                                        backgroundColor: state.isSelected
                                            ? '#805AD5'
                                            : state.isFocused
                                            ? colorbghover
                                            : 'transparent',
                                        color: state.isSelected ? '#fff' : selectColor,
                                        borderRadius: '8px',
                                        fontSize: '14px',
                                        padding: '8px 12px',
                                        cursor: 'pointer',
                                        transition: 'background-color 0.15s',
                                    }),
                                    singleValue: (provided) => ({
                                        ...provided,
                                        color: selectColor,
                                        fontSize: '14px',
                                    }),
                                    placeholder: (provided) => ({
                                        ...provided,
                                        color: '#a0aec0',
                                        fontSize: '14px',
                                    }),
                                    input: (provided) => ({
                                        ...provided,
                                        color: selectColor,
                                        fontSize: '14px',
                                    }),
                                    clearIndicator: (provided) => ({
                                        ...provided,
                                        color: '#a0aec0',
                                        cursor: 'pointer',
                                        padding: '4px',
                                        '&:hover': { color: '#e53e3e' },
                                    }),
                                    dropdownIndicator: (provided) => ({
                                        ...provided,
                                        color: '#a0aec0',
                                        padding: '4px 8px',
                                        '&:hover': { color: '#805AD5' },
                                    }),
                                    indicatorSeparator: (provided) => ({
                                        ...provided,
                                        backgroundColor: selectBorder,
                                    }),
                                    loadingIndicator: (provided) => ({
                                        ...provided,
                                        color: '#805AD5',
                                    }),
                                }}
                            />
                        </Box>
                        <Popover placement="bottom-start">
                            <PopoverTrigger>
                                <InputGroup w={{ base: "100%", md: "220px" }} cursor="pointer">
                                    <Input
                                        readOnly
                                        placeholder={t("Filtrer par date...")}
                                        value={dateStartFilter && dateEndFilter ? `${format(new Date(dateStartFilter), 'dd/MM/yyyy')} - ${format(new Date(dateEndFilter), 'dd/MM/yyyy')}` : ""}
                                        rounded="xl"
                                        cursor="pointer"
                                    />
                                    <InputRightElement children={<Icon as={ChevronRightIcon} transform="rotate(90deg)" />} />
                                </InputGroup>
                            </PopoverTrigger>
                            <PopoverContent p={0} rounded="xl" shadow="2xl" border="0" w="auto" maxW="unset">
                                <Box bg={colorbg} rounded="xl" overflow="hidden">
                                    <Flex p={2} borderBottomWidth="1px" justify="space-between" align="center">
                                        <Text fontSize="sm" fontWeight="bold" ml={2}>{t("Sélectionner une période")}</Text>
                                        <Button size="xs" variant="ghost" colorScheme="red" onClick={() => {
                                            setDateStartFilter("");
                                            setDateEndFilter("");
                                            setFilterDateRange([{ startDate: new Date(), endDate: new Date(), key: 'selection' }]);
                                        }}>{t("Effacer")}</Button>
                                    </Flex>
                                    <DateRange
                                        onChange={item => {
                                            setFilterDateRange([item.selection]);
                                            setDateStartFilter(format(item.selection.startDate, 'yyyy-MM-dd'));
                                            setDateEndFilter(format(item.selection.endDate, 'yyyy-MM-dd'));
                                        }}
                                        ranges={filterDateRange}
                                        maxDate={new Date()}
                                        locale={fr}
                                        rangeColors={['#805AD5']}
                                    />
                                </Box>
                            </PopoverContent>
                        </Popover>
                        <Button onClick={onOpenDrawer} leftIcon={<IoBarChartSharp />} variant="ghost" colorScheme="teal" rounded="xl">{t("Stats")}</Button>
                        <IconButton
                            icon={<RiFileExcel2Fill />}
                            onClick={onOpenExportAlert}
                            colorScheme="green"
                            variant="outline"
                            rounded="xl"
                            aria-label={t("Exporter Excel")}
                            title={t("Exporter en Excel")}
                        />
                        <IconButton
                            icon={<GrPowerReset />}
                            onClick={resetFilters}
                            variant="outline"
                            colorScheme="purple"
                            rounded="xl"
                            aria-label={t("Réinitialiser")}
                            title={t("Réinitialiser les filtres")}
                        />
                    </Flex>

                    <TableContainer>
                        <Table variant='simple'>
                            <Thead>
                                <Tr>
                                    <Th borderBottomColor='gray.400'>{t("Titre")}</Th>
                                    <Th borderBottomColor='gray.400' w="350px">Description</Th>
                                    <Th borderBottomColor='gray.400'>{t("Catégorie")}</Th>
                                    <Th borderBottomColor='gray.400'>{t("Montant")}</Th>
                                    <Th borderBottomColor='gray.400'>{t("Date de charge")}</Th>
                                    <Th borderBottomColor='gray.400'>{t("Reçus")}</Th>
                                    <Th borderBottomColor='gray.400'>Options</Th>
                                </Tr>
                            </Thead>
                            <Tbody>
                                {loadingData ? (
                                    <Tr><Td colSpan={7}><Skeleton height="20px" count={5} /></Td></Tr>
                                ) : data.length === 0 ? (
                                    <Tr><Td colSpan={7} textAlign="center">{t("Aucune charge trouvée")}</Td></Tr>
                                ) : data.map((row) => (
                                    <Tr key={row.id}>
                                        <Td>{row.title}</Td>
                                        <Td>
                                            <Box fontSize="sm">
                                                {row.description ? (
                                                    <>
                                                        {!expandedRows[row.id] ? (
                                                            <>
                                                                <Text display="inline">
                                                                    {row.description && row.description.length > 30 ? row.description.substring(0, 30) + "..." : row.description}
                                                                </Text>
                                                                {row.description && row.description.length > 30 && (
                                                                    <Text as="span" color="purple.500" ml={1} fontSize="xs" fontWeight="bold" cursor="pointer" onClick={() => toggleRow(row.id)}>
                                                                        ({t("voir plus")})
                                                                    </Text>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <>
                                                                <Text display="inline" whiteSpace="normal" wordBreak="break-word">
                                                                    {row.description}
                                                                </Text>
                                                                <Text as="span" color="purple.500" ml={1} fontSize="xs" fontWeight="bold" cursor="pointer" onClick={() => toggleRow(row.id)}>
                                                                    ({t("réduire")})
                                                                </Text>
                                                            </>
                                                        )}
                                                    </>
                                                ) : "-"}
                                            </Box>
                                        </Td>
                                        <Td>
                                            <Flex gap={1} align="center" wrap="wrap">
                                                <Badge colorScheme="purple" p={1} px={2} rounded="md">{getCategoryLabel(row.category)}</Badge>
                                                {row.category === "Marketing" && row.marketing_type && (
                                                    <Badge colorScheme="blue" p={1} px={2} rounded="md">{row.marketing_type}</Badge>
                                                )}
                                            </Flex>
                                        </Td>
                                        <Td>
                                            <Flex gap={1} alignItems="center">
                                                <Text fontWeight='semibold'>{row.amount}</Text>
                                                <Text fontSize={12} >{currentBusiness?.currency}</Text>
                                            </Flex>
                                        </Td>
                                        <Td fontSize="sm">
                                            {row.date_debut ? `${new Date(row.date_debut).toLocaleDateString()} - ${new Date(row.date_fin).toLocaleDateString()}` : new Date(row.date_charge).toLocaleDateString()}
                                        </Td>
                                        <Td>
                                            <HStack spacing={1}>
                                                {((row.receipts && row.receipts.length > 0) || row.recu) ? (
                                                    [...(row.receipts || []), ...(row.recu ? [{ file: row.recu, isLegacy: true }] : [])].map((r, i) => {
                                                        const isPdf = r.file?.toLowerCase().endsWith('.pdf');
                                                        return (
                                                            <Tooltip key={i} label={`${t("Reçu")} #${i + 1}${r.isLegacy ? ' (Ancien)' : ''}`}>
                                                                <Link href={r.file} isExternal>
                                                                    <Center w="30px" h="30px" bg={isPdf ? "red.50" : "blue.50"} color={isPdf ? "red.500" : "blue.500"} rounded="lg" border="1px solid" borderColor={isPdf ? "red.200" : "blue.200"}>
                                                                        <Icon as={isPdf ? FaFilePdf : FaImage} fontSize="14px" />
                                                                    </Center>
                                                                </Link>
                                                            </Tooltip>
                                                        )
                                                    })
                                                ) : (
                                                    <Text color="gray.400">-</Text>
                                                )}
                                            </HStack>
                                        </Td>
                                        <Td>
                                            <Menu>
                                                <MenuButton as={IconButton} icon={<HamburgerIcon />} variant="ghost" rounded="full" />
                                                <MenuList bg={colorbg}>
                                                    <MenuItem icon={<EditIcon />} _hover={{ bg: colorbghover }} onClick={() => {
                                                        setIsEdit(true); setChargeId(row.id); setChargeData(row);
                                                        setTitle(row.title); setDescription(row.description);
                                                        setAmount(row.amount); setDateCharge(row.date_charge || "");
                                                        setDateDebut(row.date_debut || ""); setDateFin(row.date_fin || "");
                                                        setIsRange(!!row.date_debut); setSelectedOption(row.category);
                                                        setMarketingType(row.marketing_type || "");
                                                        setSelectedProduct(row.product ? { value: row.product, label: row.product_title || t("Produit ") + row.product } : null);

                                                        // Initialize date range for calendar
                                                        const start = row.date_debut ? new Date(row.date_debut) : (row.date_charge ? new Date(row.date_charge) : new Date());
                                                        const end = row.date_fin ? new Date(row.date_fin) : (row.date_charge ? new Date(row.date_charge) : new Date());
                                                        setDateRange([{ startDate: start, endDate: end, key: 'selection' }]);

                                                        onOpen();
                                                    }}>{t("Modifier")}</MenuItem>
                                                    <MenuItem icon={<DeleteIcon />} _hover={{ bg: colorbghover }} color="red.500" onClick={() => { setDeleteType("charge"); setChargeId(row.id); onOpenAlert(); }}>{t("Supprimer")}</MenuItem>
                                                </MenuList>
                                            </Menu>
                                        </Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </TableContainer>

                    {data && data.length > 0 && (
                        <Flex mt={6} justify="space-between" align="center">
                            <MyPagination
                                paginationData={paginationData}
                                currentPage={currentPage}
                                setCurrentPage={setCurrentPage}
                                PAGE_SIZE={pageSize}
                            />
                            <Select w="100px" value={pageSize} onChange={handlePageSizeChange} rounded="xl">
                                <option value="10">10</option>
                                <option value="20">20</option>
                                <option value="50">50</option>
                            </Select>
                        </Flex>
                    )}
                </CardBody>
            </Card>

            <Modal isOpen={isOpen} onClose={() => { onClose(); empty(); }} size="xl">
                <ModalOverlay backdropFilter="blur(4px)" />
                <ModalContent rounded="2xl">
                    <ModalHeader borderBottomWidth="1px">{isEdit ? t("Modifier la charge") : t("Ajouter une charge")}</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody py={6}>
                        {message && <Alert status='error' mb={4} rounded="xl"><AlertIcon />{message}</Alert>}
                        <Stack spacing={4}>
                            <FormControl isRequired>
                                <FormLabel>{t("Titre")}</FormLabel>
                                <Input placeholder={t("Titre de la charge...")} value={title} onChange={(e) => setTitle(e.target.value)} rounded="xl" />
                            </FormControl>
                            <FormControl isRequired>
                                <FormLabel>{t("Catégorie")}</FormLabel>
                                <Select
                                    placeholder={t("Sélectionnez une catégorie")}
                                    value={selectedOption}
                                    onChange={(e) => {
                                        const val = e.target.value;
                                        setSelectedOption(val);
                                        if (val !== "Marketing") {
                                            setMarketingType("");
                                        }
                                    }}
                                    rounded="xl"
                                    isDisabled={isEdit && selectedOption === "Stock"}
                                >
                                    {categories.map(c => (
                                        <option key={c.key} value={c.key} disabled={c.key === "Stock"}>
                                            {c.label}
                                        </option>
                                    ))}
                                </Select>
                            </FormControl>
                            {selectedOption === "Marketing" && (
                                <FormControl isRequired>
                                    <FormLabel>{t("Type de Marketing")}</FormLabel>
                                    <Select
                                        placeholder={t("Sélectionnez le type de marketing")}
                                        value={marketingType}
                                        onChange={(e) => setMarketingType(e.target.value)}
                                        rounded="xl"
                                    >
                                        <option value="Facebook">Facebook</option>
                                        <option value="Snapshat">Snapshat</option>
                                        <option value="Instagram">Instagram</option>
                                        <option value="Google">Google</option>
                                        <option value="YouTube">YouTube</option>
                                        <option value="TikTok">TikTok</option>
                                        <option value="Pinterest">Pinterest</option>
                                        <option value="LinkedIn">LinkedIn</option>
                                        <option value="Autre">Autre</option>
                                    </Select>
                                </FormControl>
                            )}
                            <FormControl isRequired>
                                <FormLabel gap={1} alignItems="center" display={"flex"}>
                                    <Text>{t("Montant")}</Text>
                                    <Text fontSize={12}>{currentBusiness?.currency}</Text>
                                </FormLabel>
                                <Input type="text" placeholder={t("0.00")} value={amount} onChange={(e) => setAmount(handlePriceChange(e.target.value))} rounded="xl" />
                            </FormControl>
                            <FormControl isRequired>
                                <FormLabel>{t("Date / Période")}</FormLabel>
                                <Popover placement="bottom-start" matchWidth>
                                    <PopoverTrigger>
                                        <InputGroup cursor="pointer">
                                            <Input
                                                readOnly
                                                placeholder={t("Choisir une date ou période")}
                                                value={isRange ?
                                                    (dateDebut && dateFin ? `${format(new Date(dateDebut), 'dd/MM/yyyy')} - ${format(new Date(dateFin), 'dd/MM/yyyy')}` : t("Période...")) :
                                                    (dateCharge ? format(new Date(dateCharge), 'dd/MM/yyyy') : "")}
                                                rounded="xl"
                                                cursor="pointer"
                                            />
                                            <InputRightElement children={<Icon as={ChevronRightIcon} transform="rotate(90deg)" />} />
                                        </InputGroup>
                                    </PopoverTrigger>
                                    <PopoverContent p={0} rounded="xl" shadow="2xl" border="0" w="auto" maxW="unset">
                                        <Box bg={colorbg} rounded="xl" overflow="hidden">
                                            <Flex p={2} borderBottomWidth="1px" justify="space-between" align="center">
                                                <Button size="xs" colorScheme="purple" variant={!isRange ? "solid" : "ghost"} onClick={() => setIsRange(false)}>{t("Date Unique")}</Button>
                                                <Button size="xs" colorScheme="purple" variant={isRange ? "solid" : "ghost"} onClick={() => setIsRange(true)}>{t("Période")}</Button>
                                            </Flex>
                                            <DateRange
                                                editableDateInputs={true}
                                                onChange={item => {
                                                    const { startDate, endDate } = item.selection;
                                                    setDateRange([item.selection]);
                                                    if (isRange) {
                                                        setDateDebut(format(startDate, 'yyyy-MM-dd'));
                                                        setDateFin(format(endDate, 'yyyy-MM-dd'));
                                                    } else {
                                                        setDateCharge(format(startDate, 'yyyy-MM-dd'));
                                                    }
                                                }}
                                                moveRangeOnFirstSelection={false}
                                                ranges={dateRange}
                                                maxDate={new Date()}
                                                locale={fr}
                                                rangeColors={['#805AD5']}
                                            />
                                        </Box>
                                    </PopoverContent>
                                </Popover>
                            </FormControl>
                            <FormControl>
                                <FormLabel>{t("Produit associé")}</FormLabel>
                                <AsyncPaginate
                                    loadOptions={loadProductOptions}
                                    additional={{ page: 1 }}
                                    placeholder={t("Sélectionnez un produit...")}
                                    isClearable
                                    onChange={setSelectedProduct}
                                    value={selectedProduct}
                                    noOptionsMessage={() => t("Aucun produit trouvé")}
                                    styles={{
                                        control: (baseStyles) => ({
                                            ...baseStyles,
                                            backgroundColor: 'transparent',
                                            borderColor: 'var(--chakra-colors-gray-200)',
                                            _dark: {
                                                borderColor: 'var(--chakra-colors-whiteAlpha-300)'
                                            }
                                        }),
                                        menu: (provided) => ({
                                            ...provided,
                                            backgroundColor: colorbg,
                                            zIndex: 9999
                                        }),
                                        option: (provided, state) => ({
                                            ...provided,
                                            backgroundColor: state.isFocused ? colorbghover : colorbg,
                                            color: txtcolor,
                                            cursor: 'pointer'
                                        }),
                                        singleValue: (provided) => ({
                                            ...provided,
                                            color: txtcolor,
                                        })
                                    }}
                                />
                            </FormControl>
                            <FormControl>
                                <FormLabel>{t("Description")}</FormLabel>
                                <Textarea placeholder={t("Détails de la charge...")} value={description} onChange={(e) => setDescription(e.target.value)} rounded="xl" rows={3} />
                            </FormControl>
                            <FormControl>
                                <FormLabel>{t("Nouveaux Reçus")}</FormLabel>
                                <Box border="2px dashed" borderColor="gray.200" p={4} rounded="xl" textAlign="center" cursor="pointer" position="relative" _hover={{ bg: 'gray.50' }}>
                                    <Input type="file" multiple accept="image/*,.pdf" opacity={0} position="absolute" top={0} left={0} w="100%" h="100%" cursor="pointer"
                                        onChange={async (e) => {
                                            const files = Array.from(e.target.files);
                                            const valid = [];
                                            for (const f of files) {
                                                if (f.type.startsWith('image/')) {
                                                    const r = await new Promise(res => Resizer.imageFileResizer(f, 800, 800, 'JPEG', 80, 0, res, 'file'));
                                                    valid.push(r);
                                                } else valid.push(f);
                                            }
                                            setReceipts([...receipts, ...valid]);
                                        }}
                                    />
                                    <AttachmentIcon color="gray.400" mb={2} />
                                    <Text fontSize="sm" color="gray.500">{t("Cliquez pour ajouter des fichiers")}</Text>
                                </Box>
                                <HStack mt={2} wrap="wrap">
                                    {receipts.map((f, i) => (
                                        <Badge key={i} colorScheme="purple" p={1} px={2} rounded="md" display="flex" alignItems="center">
                                            <Text fontSize="xs">{f.name.substring(0, 10)}...</Text>
                                            <IconButton size="xs" ml={2} icon={<CloseIcon />} variant="ghost" onClick={() => setReceipts(receipts.filter((_, idx) => idx !== i))} />
                                        </Badge>
                                    ))}
                                </HStack>
                            </FormControl>
                            {isEdit && (chargeData?.recu || (chargeData?.receipts && chargeData.receipts.length > 0)) && (
                                <FormControl mt={4}>
                                    <FormLabel>{t("Reçus déjà enregistrés")}</FormLabel>
                                    <HStack spacing={2} wrap="wrap">
                                        {chargeData.recu && (
                                            <Badge colorScheme="blue" p={1} px={2} rounded="md" display="flex" alignItems="center">
                                                <Link href={chargeData.recu} isExternal>{t("Ancien")}</Link>
                                                <IconButton size="xs" ml={2} icon={<CloseIcon />} variant="ghost" colorScheme="red" onClick={() => confirmDeleteReceipt('legacy')} />
                                            </Badge>
                                        )}
                                        {chargeData.receipts?.map((r, i) => (
                                            <Badge key={r.id} colorScheme="green" p={1} px={2} rounded="md" display="flex" alignItems="center">
                                                <Link href={r.file} isExternal>{t("Reçu")} {i + 1}</Link>
                                                <IconButton size="xs" ml={2} icon={<CloseIcon />} variant="ghost" colorScheme="red" onClick={() => confirmDeleteReceipt(r.id)} />
                                            </Badge>
                                        ))}
                                    </HStack>
                                </FormControl>
                            )}
                        </Stack>
                    </ModalBody>
                    <ModalFooter>
                        <Button variant="ghost" mr={3} onClick={() => { onClose(); empty(); }}>{t("Annuler")}</Button>
                        <Button colorScheme={isEdit ? "blue" : "purple"} onClick={() => isEdit ? UpdateCharge(chargeId) : AjoutCharge()}>
                            {isEdit ? t("Enregistrer") : t("Ajouter")}
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <AlertDialog isOpen={isAlertOpen} leastDestructiveRef={cancelRef} onClose={onCloseAlert}>
                <AlertDialogOverlay backdropFilter="blur(3px)">
                    <AlertDialogContent rounded="2xl">
                        <AlertDialogHeader fontSize="lg" fontWeight="bold">
                            {deleteType === "charge" ? t("Supprimer la charge") : t("Supprimer le reçu")}
                        </AlertDialogHeader>
                        <AlertDialogBody>
                            {deleteType === "charge"
                                ? t("Êtes-vous sûr de vouloir supprimer cette charge ? Cette action est irréversible.")
                                : t("Êtes-vous sûr de vouloir supprimer ce reçu ?")}
                        </AlertDialogBody>
                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onCloseAlert}>{t("Annuler")}</Button>
                            <Button colorScheme="red" onClick={() => handleDelete(chargeId)} ml={3}>{t("Supprimer")}</Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>

            <AlertDialog isOpen={isExportAlertOpen} leastDestructiveRef={cancelRef} onClose={onCloseExportAlert}>
                <AlertDialogOverlay backdropFilter="blur(3px)">
                    <AlertDialogContent rounded="2xl">
                        <AlertDialogHeader fontSize="lg" fontWeight="bold">
                            {t("Confirmer l'exportation")}
                        </AlertDialogHeader>
                        <AlertDialogBody>
                            {t("Attention : l'exportation Excel dépendra des filtres actuellement appliqués sur la page. Voulez-vous continuer ?")}
                        </AlertDialogBody>
                        <AlertDialogFooter>
                            <Button ref={cancelRef} onClick={onCloseExportAlert}>{t("Annuler")}</Button>
                            <Button colorScheme="green" onClick={() => { onCloseExportAlert(); handleExportExcel(); }} ml={3}>{t("Exporter")}</Button>
                        </AlertDialogFooter>
                    </AlertDialogContent>
                </AlertDialogOverlay>
            </AlertDialog>

            <Drawer placement='right' size="xl" onClose={onCloseDrawer} isOpen={isDrawerOpen}>
                <DrawerOverlay />
                <DrawerContent>
                    <DrawerCloseButton />
                    <DrawerHeader borderBottomWidth='1px'>{t("Statistiques")}</DrawerHeader>
                    <DrawerBody>
                        <Box w='100%' minH="400px"><Bar data={dataChart} options={options} /></Box>
                    </DrawerBody>
                </DrawerContent>
            </Drawer>
        </Box>
    );
}

export default GestCharges;